/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const Reedem_Interval = setInterval(()=>{
  if(document.querySelector('[data-lion-account]')){
   const reedem_point_container = document.querySelector('[data-lion-account]');
    if(reedem_point_container){
      const reedem_points_div = reedem_point_container.querySelector('lionpoints');
      if(reedem_points_div){
        let reedem_points = parseFloat(reedem_points_div.innerText.replace(/,/g, ''));
        let max_reedem_point = parseFloat(document.querySelector('[data-max-reedem-point]').getAttribute('data-max-reedem-point'));
        const current_reedem_point_div = document.querySelector('[data-current-reedem-point]');
        
        console.log("Reedem Points: ",reedem_points);
        console.log("max_reedem_point: ",max_reedem_point);

        current_reedem_point_div.setAttribute('data-current-reedem-point', reedem_points);
        
        const getPercent = parseFloat((100 * reedem_points) / max_reedem_point);
        document.querySelector('.colordiscountsProgress').style.width = getPercent + '%';
        console.log(document.querySelector('.colordiscountsProgress'));
        
        console.log(getPercent);
  
        clearInterval(Reedem_Interval);
      }
    } 
  }
},0);